/* eslint-disable react/prop-types */
import {useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import {useDecision} from '@s-ui/pde'
import Button from '@s-ui/react-atom-button'
import Layout from '@adv-mt/mt-layout-basic'
import NavigationRequireAuth from '@adv-mt/mt-navigation-require-auth'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'
import TrackingWithEventTrackHoc from '@adv-mt/mt-tracking-with-event-track-hoc'

import LinkFactory from '../../../components/LinkFactory/index.js'
import Skeleton from './Skeleton.js'

const DEFAULT_USER_TAKE_OUT_LIST = {filenames: [], messages: {}}
const DOWNLOAD_EVENT_NAME = 'Take Out User Download My Data Clicked'
const TAKEOUT_FILENAME = 'takeout.zip'

const TakeOut = ({i18n, domain, router, location, pageName}) => {
  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const {USER_PROFILE_PATTERN} = config.get('page')

  const imageUrl = urlStatics + 'images/download-illustration.svg'
  const [userTakeoutList, setUserTakeoutList] = useState(DEFAULT_USER_TAKE_OUT_LIST)
  const {messages, filenames = [], requestId} = userTakeoutList

  const {enabled: useTranscendAPI} = useDecision('ff_web_growth_takeout_migration')

  const _downloadFile = ({blob}) => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = TAKEOUT_FILENAME
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  const _getUserTakeoutFile = (filename, requestId) => {
    domain
      .get('get_user_takeout_link_use_case')
      .execute({filename, requestId, useTranscendAPI})
      .then(result => {
        if (useTranscendAPI) {
          _downloadFile(result)
        } else {
          window.location.href = result.url
        }
      })
  }

  const DownloadButtonWithEventTrack = TrackingWithEventTrackHoc(Button, DOWNLOAD_EVENT_NAME)

  const _renderTakeoutFileName = (filename, key) => {
    const fileNumber = ++key

    const _onDownloadButtonClick = () => {
      _getUserTakeoutFile(filename, requestId)
    }

    return (
      <div className="mt-UserTakeOut-listItem" key={filename}>
        <span className="mt-UserTakeOut-filename">
          {i18n.t('USER_TAKEOUT_FILE_NAME')} {fileNumber}
        </span>
        <span className="mt-UserTakeOut-expiration">{i18n.t('USER_TAKEOUT_FILE_EXPIRATION')}</span>
        <DownloadButtonWithEventTrack type="primary" onClick={_onDownloadButtonClick}>
          {i18n.t('USER_TAKEOUT_DOWNLOAD')}
        </DownloadButtonWithEventTrack>
      </div>
    )
  }

  const _renderList = () => filenames.map(_renderTakeoutFileName)

  useEffect(() => {
    domain
      .get('get_user_takeout_list_use_case')
      .execute({useTranscendAPI})
      .then(userTakeoutList => {
        setUserTakeoutList(userTakeoutList)
      })
  }, [domain, useTranscendAPI])

  return (
    <NavigationRequireAuth currentPath={location.pathname}>
      <Layout.Basic linkFactory={LinkFactory}>
        <div className="mt-UserTakeOut">
          <img className="mt-UserTakeOut-image" src={imageUrl} alt={i18n.t(messages.title)} />
          <h1 className="mt-UserTakeOut-title">{i18n.t(messages.title)}</h1>

          <p
            className="mt-UserTakeOut-subTitle"
            dangerouslySetInnerHTML={{
              __html: i18n.t(messages.subtitle, {
                linkStart: `<a title="${messages.title}" href="${USER_PROFILE_PATTERN}">`,
                linkEnd: '</a>',
                lineBreak: `<br>`
              })
            }}
          />
          {_renderList()}
        </div>
      </Layout.Basic>
      <TrackingPageView pageName={pageName} />
    </NavigationRequireAuth>
  )
}

TakeOut.renderLoading = Skeleton

TakeOut.propTypes = {
  domain: PropTypes.object,
  router: PropTypes.object,
  i18n: PropTypes.object,
  pageName: PropTypes.object
}

TakeOut.displayName = 'TakeOut'

TakeOut.getInitialProps = async ({routeInfo, context: {domain}}) => {
  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: routeInfo.location.pathname})

  return {pageName}
}

export default TakeOut
